<template>
<modal title="Edit Scraper Payload">
  <text-area v-model="payload">Payload</text-area>

  <template #footer>
    <action-button @click="save" :working="saving">Save</action-button>
  </template>
</modal>  
</template>
<script>
import { post } from '@/api/request'

export default {
  props: {
    scraper: {
      type: Object,
      default: () => ({})
    }
  },

  data: () => ({
    saving: false,
    payload: ''
  }),

  created() {
    this.payload = this.scraper.scraper_payload
  },

  methods: {
    save() {
      this.saving = true
      post(`api/super/secondary-scraper/${this.scraper.id}/payload`, {
        scraper_payload: this.payload
      }, () => this.$close(true), error => {
        this.saving = false
        console.log(error)
      })
    }
  }
}
</script>